import { useCallback } from 'react';
import { IGetFirepadInstance } from './interfaces';

export const GetFirepadInstance = (data: IGetFirepadInstance) => {
  const { firepadRef } = data;
  return useCallback(() => firepadRef.current, [firepadRef]);
};
